import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M8.006 2.875h1.16a.625.625 0 1 1 0 1.25H8.034c-.803 0-1.369 0-1.81.037-.434.035-.692.102-.892.204a2.2 2.2 0 0 0-.965.965c-.102.2-.169.458-.204.892-.037.441-.037 1.007-.037 1.81v7.934c0 .803 0 1.369.037 1.81.035.433.102.692.204.892a2.2 2.2 0 0 0 .965.965c.2.102.458.169.892.204.441.037 1.007.037 1.81.037h1.134a.625.625 0 1 1 0 1.25h-1.16c-.771 0-1.387 0-1.885-.04-.512-.042-.953-.13-1.359-.337a3.459 3.459 0 0 1-1.511-1.511c-.207-.406-.295-.847-.336-1.358-.041-.498-.041-1.115-.041-1.885V8.006c0-.77 0-1.386.04-1.884.042-.512.13-.953.337-1.359.332-.65.86-1.18 1.511-1.511.406-.207.847-.295 1.359-.336.498-.041 1.114-.041 1.884-.041Z"
    />
    <path
      fill="currentColor"
      d="M15.336 6.836a.625.625 0 0 1 .884 0l4.722 4.722a.625.625 0 0 1 0 .884l-4.722 4.722a.625.625 0 0 1-.884-.884l3.655-3.655H9.167a.625.625 0 1 1 0-1.25h9.824L15.336 7.72a.625.625 0 0 1 0-.884Z"
    />
  </svg>
`;
